let activeIndex = null;
const videoCards = document.querySelectorAll(
  "div[data-role='open-videos-modal']"
);
const modalContainer = document.querySelector("div[data-role='videos-modal']");

const modalNavs = document.querySelectorAll(".videos-modal--nav-item");

const videoPlayer = modalContainer.querySelector("video");
const modalTitle = document.querySelector(".videos-modal--title");

modalContainer.addEventListener("click", (e) => {
  if (
    e.target.dataset.role === "videos-modal" ||
    e.target.dataset.role === "close-modal"
  ) {
    changeModalVisibility("close");
  }
});

videoCards.forEach((card) => card.addEventListener("click", handleCardClick));

function handleCardClick(e) {
  const rawSources = this.dataset.sources;
  activeIndex = [...videoCards.entries()].findIndex(
    ([index, element]) => element === this
  );
  if (!rawSources) return;
  displayVideo(rawSources);
  changeModalVisibility("open");
}

modalNavs.forEach((item) => {
  item.addEventListener("click", handleModalNavClick);
});
function handleModalNavClick(e) {
  if (this.dataset.role === "next") {
    let target = 0;
    const nextElement = videoCards[activeIndex + 1];
    if (nextElement) target = activeIndex + 1;
    activeIndex = target;
    const rawSources = videoCards[target].dataset.sources;
    displayVideo(rawSources);
    return;
  }
  if (this.dataset.role === "prev") {
    let target = videoCards.length - 1;
    const prevElement = videoCards[activeIndex - 1];
    if (prevElement) target = activeIndex - 1;
    const rawSources = videoCards[target].dataset.sources;
    displayVideo(rawSources);
    activeIndex = target;
    return;
  }
}

function displayVideo(rawSources) {
  const urls = removeLastComma(rawSources).split(",");
  const sources = urls.map((url) => {
    const type = url.includes(".m3u8") ? "application/x-mpegURL" : "video/mp4";
    return { src: url, type: type };
  });
  for (const source of sources) {
    if (source.type === "video/mp4") {
      videoPlayer.src = source.src;
      break;
    }
  }
  modalTitle.innerHTML = `${activeIndex + 1}/${videoCards.length}`;
}

function removeLastComma(str) {
  const lastCommaIndex = str.lastIndexOf(",");
  if (lastCommaIndex === -1) {
    return str;
  }
  return str.slice(0, lastCommaIndex) + str.slice(lastCommaIndex + 1);
}

const TRANSITION_DURATION =
  parseFloat(getComputedStyle(modalContainer).transitionDuration) * 1000;
let isModalAnimating = false;
function changeModalVisibility(targetState) {
  if (isModalAnimating) return;
  if (targetState === "open") {
    isModalAnimating = true;
    document.body.style.overflow = "hidden";
    modalContainer.classList.remove("hidden");
    setTimeout(() => {
      modalContainer.classList.remove("invisible");
    }, 0);
    setTimeout(() => {
      isModalAnimating = false;
    }, TRANSITION_DURATION);
    return;
  }
  if (targetState === "close") {
    isModalAnimating = true;
    videoPlayer.src = "";
    document.body.style.overflow = "";
    modalContainer.classList.add("invisible");
    setTimeout(() => {
      modalContainer.classList.add("hidden");
      isModalAnimating = false;
    }, TRANSITION_DURATION);
    return;
  }
  throw new Error(`unhandled modal state:${targetState}`);
}
